<template>
  <section class="panel" v-if="isAdmin('stay')">
    <header class="panel-heading">
      <h4 class="panel-title">{{ sceneTitle }} QRCode 設定</h4>
    </header>
    <div class="panel-body container-fluid">
      <div class="row" v-for="t in dormitoryTypes" :key="t.key" style="margin-bottom: 10px;">
        <div class="col-md-2 col-sm-12" style="padding-top: 25px;">
          <strong>{{ t.text }}</strong>
        </div>
        <div class="col-md-2 col-sm-6">
          <label>{{ t.key === 'N' ? '學期' : '學年' }}</label>
          <input type="text" class="form-control" v-model="form[t.key].applyYm" :placeholder="t.key === 'N' ? '例如 1142' : '例如 114'" />
        </div>
        <div class="col-md-4 col-sm-6">
          <label>開始時間</label>
          <div style="display: flex; gap: 6px;">
            <div style="flex: 1 1 0; min-width: 0;">
              <datepicker
                :format="customFormatter"
                :language="zh"
                input-class="form-control"
                v-model="form[t.key].beginDate"
              ></datepicker>
            </div>
            <input type="time" class="form-control" v-model="form[t.key].beginTime" style="width: 120px; flex-shrink: 0;" />
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <label>結束時間</label>
          <div style="display: flex; gap: 6px;">
            <div style="flex: 1 1 0; min-width: 0;">
              <datepicker
                :format="customFormatter"
                :language="zh"
                input-class="form-control"
                v-model="form[t.key].endDate"
              ></datepicker>
            </div>
            <input type="time" class="form-control" v-model="form[t.key].endTime" style="width: 120px; flex-shrink: 0;" />
          </div>
        </div>
        <div class="col-md-2 col-sm-6" v-if="showEnabled">
          <label>啟用</label>
          <select class="form-control" v-model="form[t.key].enabled">
            <option value="Y">啟用</option>
            <option value="N">停用</option>
          </select>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-md-12 text-right">
          <button class="btn btn-primary" @click="saveSetting">儲存設定</button>
        </div>
      </div>

      <div class="row form-group" v-if="enableOpen">
        <div class="col-md-12">
          <hr />
          <h5>開啟 {{ sceneTitle }} QRCode</h5>
        </div>
        <div class="col-md-3 form-group">
          <label>住宿類別</label>
          <select class="form-control" v-model="activeType">
            <option v-for="t in dormitoryTypes" :key="t.key" :value="t.key">{{ t.text }}</option>
          </select>
        </div>
        <div class="col-md-9 form-group text-right" style="padding-top: 26px;">
          <button class="btn btn-danger" @click="openQrcode">開啟 QRCode</button>
          <button class="btn btn-default" @click="closeQrcode" v-if="qrcodeUrl">關閉</button>
        </div>
        <div class="col-md-12" v-if="qrcodeUrl">
          <div class="well text-center">
            <p>此 QRCode 每 5 分鐘自動更新一次</p>
            <img :src="qrcodeUrl" alt="qrcode" style="width: 260px; height: 260px;" />
            <p style="margin-top: 10px;">有效至：{{ expireText }}</p>
            <button class="btn btn-default" @click="copyToClipboard(qrcodeLink)">複製連結</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    sceneKey: {
      type: String,
      required: true,
    },
    sceneTitle: {
      type: String,
      required: true,
    },
    enableOpen: {
      type: Boolean,
      default: false,
    },
    showEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dormitoryTypes: [
        { key: "N", text: "一般宿舍" },
        { key: "V", text: "寒暑假宿舍" },
        { key: "S", text: "特殊宿舍" },
      ],
      form: {
        N: { applyYm: "", beginDate: null, beginTime: "", endDate: null, endTime: "", enabled: "N" },
        V: { applyYm: "", beginDate: null, beginTime: "", endDate: null, endTime: "", enabled: "N" },
        S: { applyYm: "", beginDate: null, beginTime: "", endDate: null, endTime: "", enabled: "N" },
      },
      activeType: "N",
      qrcodeUrl: "",
      qrcodeLink: "",
      expireText: "",
      refreshTimerId: null,
    };
  },
  mounted() {
    this.loadSetting();
  },
  beforeDestroy() {
    this.clearRefreshTimer();
  },
  methods: {
    loadSetting() {
      this.$axios.post(`/api/Common/qrcodeSetting/${this.sceneKey}`).then((resp) => {
        const list = (resp.data && resp.data.data && resp.data.data.qrcodeSettingList) || [];
        this.dormitoryTypes.forEach((t) => {
          const applyYm = list.find((a) => a.commCode === `APPLY_YM_${t.key}`);
          const period = list.find((a) => a.commCode === `PERIOD_${t.key}`);
          const enabled = list.find((a) => a.commCode === `ENABLED_${t.key}`);
          this.form[t.key].applyYm = (applyYm && applyYm.commValue) || "";
          this.form[t.key].enabled = ((enabled && enabled.commValue) || "N").toUpperCase() === "Y" ? "Y" : "N";
          if (period && period.commValue) {
            const beginParts = period.commValue.split(" ");
            this.form[t.key].beginDate = beginParts[0] ? this.dateFormatter(beginParts[0]) : null;
            this.form[t.key].beginTime = beginParts[1] || "";
          }
          if (period && period.commValue2) {
            const endParts = period.commValue2.split(" ");
            this.form[t.key].endDate = endParts[0] ? this.dateFormatter(endParts[0]) : null;
            this.form[t.key].endTime = endParts[1] || "";
          }
        });
      });
    },
    buildPayload() {
      const payload = [];
      this.dormitoryTypes.forEach((t, index) => {
        const row = this.form[t.key];
        payload.push({
          commCode: `APPLY_YM_${t.key}`,
          commValue: row.applyYm || "",
          commValue2: "",
          commSort: index * 3 + 1,
        });
        payload.push({
          commCode: `PERIOD_${t.key}`,
          commValue: row.beginDate && row.beginTime ? `${this.customFormatter(row.beginDate)} ${row.beginTime}` : "",
          commValue2: row.endDate && row.endTime ? `${this.customFormatter(row.endDate)} ${row.endTime}` : "",
          commSort: index * 3 + 2,
        });
        if (this.showEnabled) {
          payload.push({
            commCode: `ENABLED_${t.key}`,
            commValue: row.enabled || "N",
            commValue2: "",
            commSort: index * 3 + 3,
          });
        }
      });
      return payload;
    },
    saveSetting() {
      const payload = this.buildPayload();
      this.$axios.post(`/api/Common/saveQrcodeSetting/${this.sceneKey}`, payload).then((resp) => {
        if (resp.data.status === "success") {
          bootbox.alert("QRCode 設定儲存成功");
        } else {
          bootbox.alert(resp.data.msg || "儲存失敗");
        }
      });
    },
    clearRefreshTimer() {
      if (this.refreshTimerId) {
        clearInterval(this.refreshTimerId);
        this.refreshTimerId = null;
      }
    },
    closeQrcode() {
      this.clearRefreshTimer();
      this.qrcodeUrl = "";
      this.qrcodeLink = "";
      this.expireText = "";
    },
    openQrcode() {
      const row = this.form[this.activeType];
      if (!row.applyYm) {
        bootbox.alert("請先設定學期");
        return;
      }
      if (!row.beginDate || !row.beginTime || !row.endDate || !row.endTime) {
        bootbox.alert("請先設定完整開放期間");
        return;
      }
      if (this.showEnabled && row.enabled !== "Y") {
        bootbox.alert("此住宿類別尚未啟用 QRCode");
        return;
      }

      const refresh = () => {
        this.$axios
          .post("/api/Room/generateCheckinQrcodeToken", {
            smtr: row.applyYm,
            dormitoryType: this.activeType,
          })
          .then((resp) => {
            if (resp.data.status !== "success") {
              this.closeQrcode();
              bootbox.alert(resp.data.msg || "QRCode 產生失敗");
              return;
            }
            const data = resp.data.data;
            this.qrcodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${encodeURIComponent(data.url)}`;
            this.qrcodeLink = data.url;
            this.expireText = this.customFormatter(data.expireAt, "YYYY/MM/DD HH:mm:ss");
          });
      };

      refresh();
      this.clearRefreshTimer();
      this.refreshTimerId = setInterval(refresh, 5 * 60 * 1000);
    },
  },
};
</script>

<style scoped>
</style>
